import React from 'react';
import ProcessScheduleMeeting from '../features/process-client/ProcessScheduleMeeting';

const ProcessMeetingRoutes = () => {
  return (
    <div className="app-container">
      <div>
        <ProcessScheduleMeeting/>
      </div>
    </div>
    
  );
};

export default ProcessMeetingRoutes;